import { plansService } from '@/_services'

const getDefaultState = () => {
  return {
    all: [
      {},
      {
        id: 1,
        name: "Starter",
        img: "3",
        contacts: "150contactspermonth",
        data: {
          findcontacts: {
            unlockusecontacts: { period: "month", qty: 150 },
            exportandenrichcontactsgm: "unlimited",
            exportandenrichcontactsli: { period: "day", qty: 1000 },
            importyourowncontacts: "2000",
          },
          coldemailoutreach: {
            emailcampaignrunningatthesametime: "1",
            "connectyoure-mail": "yes",
            trackemailperformances: "yes",
          },
          analysisandfollowup: {
            analyzeprospectbehavioronyourwebsite: "yes",
            automatedtasksgeneration: "yes",
            chatsupport: "yes",
            opportunitiescsvexport: "no",
            connectwithyourcrm: "no",
            createyourowncustomvariables: "no",
            "advances statistics": "no",
          },
        },
      },
      {
        id: 2,
        name: "Advanced",
        img: "2",
        contacts: "unlimitedcontacts",
        data: {
          findcontacts: {
            unlockusecontacts: "unlimited",
            exportandenrichcontactsgm: "unlimited",
            exportandenrichcontactsli: { period: "day", qty: 1000 },
            importyourowncontacts: "unlimited",
          },
          coldemailoutreach: {
            emailcampaignrunningatthesametime: "3",
            "connectyoure-mail": "yes",
            trackemailperformances: "yes",
          },
          analysisandfollowup: {
            analyzeprospectbehavioronyourwebsite: "yes",
            automatedtasksgeneration: "yes",
            chatemailphonesupport: "yes",
            opportunitiescsvexport: "yes",
            connectwithyourcrm: "yes",
            createyourowncustomvariables: "yes",
            "advances statistics": "no",
          },
        },
      },
      {
        id: 3,
        img: "5",
        name: "Pro",
        contacts: "unlimitedcontacts",
        data: {
          findcontacts: {
            unlockusecontacts: "unlimited",
            exportandenrichcontactsgm: "unlimited",
            exportandenrichcontactsli: { period: "day", qty: 1000 },
            importyourowncontacts: "unlimited",
          },
          coldemailoutreach: {
            emailcampaignrunningatthesametime: "unlimited",
            "connectyoure-mail": "yes",
            trackemailperformances: "yes",
          },
          analysisandfollowup: {
            analyzeprospectbehavioronyourwebsite: "yes",
            automatedtasksgeneration: "yes",
            dedicatedtrainer: "yes",
            opportunitiescsvexport: "yes",
            connectwithyourcrm: "yes",
            createyourowncustomvariables: "yes",
            "advances statistics": "yes",
          },
        },
      },
      {
        id: 4,
        img: "5",
        name: "Oliverlist Data",
        contacts: "optionoliverlist",
        data: {
          findcontacts: {
            accessallcontacts: "yes",
            downloadcsv: "yes",
            sendtocrmmanually: "yes",
            syncontactscrm: "yes",
            last_interaction: "yes",
            email_opens: "yes",
            email_clics: "yes",
            email_replies: "yes",
            meeting: "yes",
            last_meeting: "yes",
            first_contact: "yes",
            last_email: "yes",
          },
        },
      },
      {
        id: 5,
        img: "5",
        name: "Connect Pulse",
        contacts: "powerpack",
        data: {
          launch_price: { success_fee: "yes" },
          instantly_unlock: {
            premium_bizdev: [
              "premium_bizdev_subitem1",
              "premium_bizdev_subitem2",
            ],
            aicopilot: [
              "aicopilot_subitem1",
              "aicopilot_subitem2",
              "aicopilot_subitem3",
            ],
            priorization_smart: [
              "priorization_smart_subitem1",
              "priorization_smart_subitem2",
            ],
            transparency_performance: [
              "transparency_performance_subitem1",
              "transparency_performance_subitem2",
            ],
          },
          why_unique: {
            why_unique_item1: "yes",
            why_unique_item2: "yes",
            why_unique_item3: "yes",
          },
          termsupgrade: {
            termsupgrade_item1: "yes",
            termsupgrade_item2: "yes",
            termsupgrade_item3: "yes",
          },
        },
      },
    ],
    allActives: [],
  };
}


  const state = getDefaultState()

  const actions = {
    getAll({ commit }, args) {
      plansService.getAll().then(
        plans => {
          commit('getAllSuccess', plans)
        }
      );
    },
  }

  const mutations = {
    getAllSuccess(state, plans) {
      state.allActives = plans;
    }
  }

  export const plans = {
    namespaced: true,
    state,
    actions,
    mutations
  }